<!-- Esse componente mostra os medicamentos e os exames que foram solicitados
pelo medico -->
<template>
<div>
    <v-card>
        <v-card-title>
            <h3>Exames e Medicamentos</h3>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title>
                                <h4>Exames</h4>
                            </v-card-title>
                            <v-card-text>
                                <v-list>
                                    <v-list-item-group>
                                        <v-list-item v-for="(item, i) in exames" :key="i" @click="item.active = !item.active">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-checkbox v-model="item.active" :label="item.active ? 'Ativo' : 'Inativo'" :value="item.active" :disabled="true"></v-checkbox>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-card-title>
                                <h4>Medicamentos</h4>
                            </v-card-title>
                            <v-card-text>
                                <v-list>
                                    <v-list-item-group>
                                        <v-list-item v-for="(item, i) in medicamentos" :key="i" @click="item.active = !item.active">
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-checkbox v-model="item.active" :label="item.active ? 'Ativo' : 'Inativo'" :value="item.active" :disabled="true"></v-checkbox>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</div>
</template>

<script>

import posAtendimentoService from '../../services/posAtendimento.service'

// O id da consulta é passado como prop para o componente
export default {
  props: {
    idConsulta: {
      type: Number,
      required: true
    },
    idSolicitacao: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      exames: [],
      medicamentos: []
    }
  },
  methods: {
    // Busca os exames e medicamentos que foram solicitados para a consulta
    getExamesMedicamentos () {
      posAtendimentoService.listarSolicitacaoMedicametos(this.idConsulta)
        .then(r => {
          // this.exames = r.data.exames
          // console.log(r.data)
          this.medicamentos = r.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    // Buscar os exames que foram solicitados para a o atendimento
    getExames () {
      posAtendimentoService.listarSolicitacaoExames(this.idSolicitacao)
        .then(r => {
          console.log('exames', r.data)
          this.exames = r.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getExamesMedicamentos()
    this.getExames()
  }
}
</script>
